import { Component, OnInit, OnDestroy, NgZone, EventEmitter, ViewChild, Input } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap/modal';

import { Subscription } from 'rxjs';

import { PresetEntityComponent } from './../preset-entity/preset-entity.component';

import {
    AuthorizationService,
    ToastrService,
    PresetService,
    Preset,
} from './../../../../shared/index';

@Component({
    selector: 'preset-filter',
    templateUrl: './preset-filter.html',
    standalone: false
})

export class PresetFilterComponent implements OnInit, OnDestroy {
    @ViewChild('presetFilter') filter: ModalDirective;

    private subscriptions: Subscription[] = [];

    public presets: Preset[] = [];

    public selectedPresets = 0;
    public filterApplied = false;
    public search = '';

    constructor(
        private _ngZone: NgZone,
        private _presetService: PresetService,
        private _toastrService: ToastrService
    ) { }

    ngOnInit(): void {
        this.subscriptions.push(this._presetService.presetChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.presets = info;
            });
        }));
        this._presetService.getPresets();
    }
    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    public showFilters(): void {
        this.filter.show();
    }

    public applyFilter(): void {
        if (this.search != '' || this.selectedPresets > 0) {
            this.filterApplied = true;
            this._presetService.setFilter(this.search, this.selectedPresets);
            this._presetService.applyFilter();
        } else {
            this.filterApplied = false;
            this._presetService.clearFilter();
            this._presetService.getPresets();
        }
        this.filter.hide();
    }

    public close(): void {
        this.filter.hide();
    }

    public clearFilter(): void {
        this._presetService.clearFilter();
        this.search = '';
        this.selectedPresets = 0;
        this.filterApplied = false;
        this._presetService.getPresets();
    }
}
